import {Injectable} from '@angular/core';
import {Http} from "@angular/http";
import { UUID } from 'angular2-uuid';

import {Sterbefall} from '../model/sterbefall';
import {SterbefallIO} from '../model/sterbefall.io';

import {GuiProvider} from '../providers/gui.provider';
import {UserProvider} from '../providers/user.provider';


@Injectable()
export class SterbefallProvider {

	/** Liste aller Sterbefälle. */
	sterbefaelle: Sterbefall[] = [];

	/** Der Sterbefall, der aktuell in Bearbeitung ist. */
	aktuellerSterbefall: Sterbefall;

	/** Maximale Anzahl an Sterbefällen.
	 * Die Zahl wurde experimentell und durch Diskussion ermittelt. 1000 Sterbefälle benötigen etwa 2 MB.
	 * 200 Sterbefälle also unter 500 kB. Die Zahl erscheint uns ausreichend und auch mobile Browser werden
	 * an kein Limit stoßen. */
	maxSterbefaelle = 200;


	constructor(
		private http: Http,
		private guiService : GuiProvider,
		private userService : UserProvider) {
		//Sterbefälle aus Local Storage laden
		let templates = JSON.parse(localStorage.getItem("sterbefaelle"));
		if (templates) {
			for (let template of templates) {
				let s = new SterbefallIO().loadSterbefall(template);
				if (s) //andernfalls ist ein Fehler aufgetreten. Ignorieren (TODO?).
					this.sterbefaelle.push(s);
			}
		}
	}

	/**
	 * Gibt sämtliche gespeicherten Sterbefälle zurück.
	 */
	getSterbefaelle() : Sterbefall[] {
		return this.sterbefaelle;
	}

	/**
	 * Gibt den Sterbefall mit der gegebenen ID zurück.
	 * Falls nicht gefunden, wird undefined zurückgegeben.
	 */
	getSterbefall(id: string) : Sterbefall {
		return this.sterbefaelle.find(s => s.id == id);
	}

	/**
	 * Speichert den gegebenen Sterbefall, auch im Local Storage.
	 * Ist ein Sterbefall mit dieser ID vorhanden, so wird er ersetzt.
	 * Andernfalls wird eine neue ID vergeben und der neue Sterbefall
	 * an den Beginn der Liste gesetzt.
	 */
	saveSterbefall(sterbefall: Sterbefall) {
		//Liste der Sterbefälle aktualisieren
		let index = this.sterbefaelle.findIndex(s => s.id == sterbefall.id);
		if (index == -1) {
			let newId = UUID.UUID();
			sterbefall.id = newId;
			this.sterbefaelle.unshift(sterbefall);
		}
		else {
			this.sterbefaelle[index] = sterbefall;
		}
		this.savePermanent();
	}

	/**
	 * Löscht den gegebenen Sterbefall, auch im Local Storage.
	 * Zurückgegeben wird die aktualisierte Liste an Sterbefällen.
	 */
	deleteSterbefall(sterbefall: Sterbefall) : Sterbefall[] {
		let index = this.sterbefaelle.findIndex(s => s.id == sterbefall.id);
		if (index > -1) {
			this.sterbefaelle.splice(index, 1);
			this.savePermanent();
		}
		return this.sterbefaelle;
	}

	/**
	 * Speichert die Liste der Sterbefälle im Local Storage.
	 */
	savePermanent() {
		let data : Object[] = [];
		for (let s of this.sterbefaelle)
			data.push(new SterbefallIO().saveSterbefall(s));
		localStorage.setItem("sterbefaelle", JSON.stringify(data));
	}

	/**
	 * Löscht die count ältesten Sterbefälle, die bereits übermittelt wurden,
	 * soweit vorhanden.
	 */
	cleanUp(count: number) {
		let deleted = 0;
		for (let i = this.sterbefaelle.length - 1; i >= 0 && count > deleted; i--) {
			if (this.sterbefaelle[i].isGesendet()) {
				this.sterbefaelle.splice(i, 1);
				deleted++;
			}
		}
	}

}



// WEBPACK FOOTER //
// ./src/providers/sterbefall.provider.ts